export default {
    ErrorGeneric: "An error occurred. Please try again.",
    ErrorFieldRequired: "This field is required.",
    ErrorEmailInvalid: "Please enter a valid email.",
    ErrorMobileInvalid: "Please enter a valid mobile number.",
    ErrorTandCsRequired: "Please accept the Terms & Conditions to continue.",
    ErrorLoadingLocations: "Error loading locations. Please try again.",
    ErrorLoadingMenu: "Error loading menu. Please try again.",
    ErrorProductForm: "Please fix the above errors.",
    ErrorSpecialCharName: "The above can only contain letters, numbers, and special characters ( ) - , . ' ! $ %",
    // Offline
    ErrorStoreClosedWeb: "Store is currently not accepting orders.",
    ErrorStoreClosedTable: "Please go to the counter to place your order.",
    // Location
    LocationWarnChange: <div>Changing the location will <span className="text-danger">clear out your cart</span>, are you sure you want to clear it and choose another location?</div>,
    LocationClosed: "This store is currently closed, please try again later.",
    // Table Number
    ErrorTableNumberInvalid: "Invalid table number.",
    // Product Selection
    ErrorSelectAProduct: "Please select a product to continue.",
    // Delivery
    ErrorDeliveryUnavailable: "Delivery is currently unavailable.",
    ErrorFieldErrors: "Some fields have errors, please confirm the above fields.",
    MethodWarnChange: <div>Changing your order type will <span className="text-danger">clear out your cart</span>, are you sure you want to clear it and start your order again?</div>,
    // Vouchers
    ErrorRedeemVoucherInStore: "To redeem this voucher, scan your card in-store.",
    ErrorVoucherInUse: "A voucher is currently in use.",
    ErrorVoucherIsInCart: "A voucher is already in your cart, please remove this before selecting another voucher.",
    // Calendar
    ErrorSelectTimeInStoreOpeningHours: "Please select a time within the store's opening hours."
}